<agr-page-detail
  [hasPrimaryAction]="!!(orderReports$ | async)?.length"
  [isEmpty]="!(orderReports$ | async)?.length"
  (primaryAction)="print()"
  (backAction)="back()"
  primaryActionIcon="print"
  [pageTitle]="
    (pageData$ | async)?.title +
    ', ' +
    (customer$ | async)?.name +
    ' (' +
    (customer$ | async)?.externalId +
    ', ' +
    ('locationExternalId' | translate) +
    ' ' +
    (location$ | async)?.externalId +
    ')'
  "
  [emptyTitle]="(pageData$ | async)?.emptyTitle | switchTranslation"
  [emptyDescription]="(pageData$ | async)?.emptyDescription"
  [primaryActionText]="(pageData$ | async)?.primaryActionText"
>
  <agr-print-page [footerText]="'orderReportWarningFooter' | translate" [relatedPeople]="relatedPeople$ | async" [marginLeft]="true" [showPageNumber]="false">
    <app-general-info [reportForLabel]="'report.forLabel'"></app-general-info>

    <div class="print-page">
      <table class="print-page__table">
        <thead>
          <tr>
            <td class="print-page__table__header-space"></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="print-page__table__content">
              <div>
                <div class="wrapper--spacing-horizontal print-only">
                  <div class="notification notification-warning">
                    <mat-icon>warning</mat-icon>
                    <strong class="text--warning"> {{ 'orderReportWarningTitle' | translate }}</strong
                    ><br />
                    <span [innerHTML]="'orderReportWarningDescription' | translate"></span>
                  </div>
                </div>
              </div>

              <mat-accordion>
                @for (orderReport of orderReports$ | async; track orderReport) {
                  <mat-expansion-panel data-test="order-period">
                    <br />
                    <!-- We use <br> instead of class "avoid-page-break" to avoid the table cutting off -->
                    @if (orderReport.periodInfo) {
                      <mat-expansion-panel-header>
                        <mat-panel-title class="flex__child flex__child-1">
                          @if (orderReport.orderLines && (showCompleteReport$ | async)) {
                            <span>
                              <strong>{{
                                (orderReport.status === orderLineStatus.open
                                  ? 'orderStatus'
                                  : orderReport.status === orderLineStatus.inCart
                                    ? 'inCart'
                                    : orderReport.status === orderLineStatus.finalized
                                      ? 'ordered'
                                      : 'notAvailable'
                                ) | switchTranslation
                              }}</strong>
                            </span>
                          } @else {
                            <strong>{{ 'period' | translate }}:</strong> &nbsp;
                            {{ orderReport.periodInfo.name }}
                          }
                        </mat-panel-title>
                        <mat-panel-description class="flex__child flex__child-1">
                          @if (showCompleteReport$ | async) {
                            <strong>
                              {{ orderReport.periodInfo.name }}
                              &nbsp;&nbsp;</strong
                            >
                          }
                          {{ orderReport.periodInfo.startDispatchFrom | agrDate: 'longDate' }} -
                          {{ orderReport.periodInfo.deliverBefore | agrDate: 'longDate' }}
                        </mat-panel-description>
                      </mat-expansion-panel-header>
                    }
                    <table class="orderline-table" mat-table [dataSource]="orderReport.orderLines" data-test="orderline-table">
                      <ng-container matColumnDef="articleName">
                        <th mat-header-cell *matHeaderCellDef>{{ 'articleName' | translate }}</th>
                        <td mat-cell *matCellDef="let orderLine">
                          {{ orderLine.cropAid ? orderLine.cropAid?.name : '' }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="articleCode">
                        <th mat-header-cell *matHeaderCellDef>{{ 'articleCode' | translate }}</th>
                        <td mat-cell *matCellDef="let orderLine">
                          {{ orderLine.cropAid && orderLine.cropAid.codes.length ? orderLine.cropAid.codes[0] : '' }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="packaging">
                        <th mat-header-cell *matHeaderCellDef>{{ 'packaging' | translate }}</th>
                        <td mat-cell *matCellDef="let orderLine">
                          {{ orderLine.package ? orderLine.package.amount : '' }}
                          {{ orderLine.package ? orderLine.package.unitOfMeasurement : '' }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="orderQuantity">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'orderQuantity' | switchTranslation }}
                        </th>
                        <td mat-cell *matCellDef="let orderLine">{{ orderLine.count }}</td>
                      </ng-container>
                      <ng-container matColumnDef="requisite">
                        <th mat-header-cell *matHeaderCellDef>
                          {{ 'requisite' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let orderLine">
                          {{ orderLine.requisiteAmount | agrNumber }}
                          {{ orderLine.cropAid?.unitOfMeasurement }}
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="orderReport.status ? displayedColumns : displayedColumnsAlt"></tr>
                      <tr mat-row *matRowDef="let row; columns: orderReport.status ? displayedColumns : displayedColumnsAlt"></tr>
                    </table>
                  </mat-expansion-panel>
                }
              </mat-accordion>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </agr-print-page>
</agr-page-detail>
